"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlMat3Uniform = void 0;
const a_gl_uniform_array_1 = require("./a-gl-uniform-array");
/**
 * @public
 * Wrapper for webgl float matrix3 uniform.
 */
class GlMat3Uniform extends a_gl_uniform_array_1.AGlUniformArray {
    bind(renderer) {
        if (!this.isDirty) {
            return;
        }
        const data = this.data;
        renderer.context.uniformMatrix3fv(this.uniformLocation, this.transpose, data);
        this.isDirty = false;
    }
}
exports.GlMat3Uniform = GlMat3Uniform;
//# sourceMappingURL=gl-mat3-uniform.js.map